import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../../user/user-subscription";
import {ChosenPlan} from "../../../../../payment-info/models/plan.model";
import {GoogleAnalyticsService} from "../../../../../../services/google-analytics/google-analytics.service";
import {TextUtils} from "../../../../../../utils/text-utils";
import planFeatures from "./plans-features.json";
import {CopilotVideoComponent} from "../copilot-video/copilot-video.component";
import {DbModalService} from "../../../../../../../modules/modal/modal";

@Component({
    selector: "db-one-week-free-demo-plan",
    templateUrl: "./one-week-free-demo-plan.component.html",
    styleUrls: ["./one-week-free-demo-plan.component.scss"],
    standalone: false
})
export class OneWeekFreeDemoPlanComponent implements OnInit, OnDestroy {
  @ViewChild('aiBuilderVideo') aiBuilderVideo: ElementRef<HTMLVideoElement>;

  @Input() singlePlanMode: boolean = false;
  @Input() showFirstTime: boolean = false;
  @Input() isEcommerceWebsite: boolean = false;
  @Input() isAgency: boolean = false;
  @Input() mostPopular: boolean = false;
  @Input() paidFeature?: boolean = false;
  @Input() title: string;
  @Input() activeTab: string;
  @Input() domainName?: string;
  @Input() description: string = null;
  @Input() planDesc: string = null;
  @Input() plan: any[];
  @Input() subscription: UserSubscription;
  @Input() periodSwitchValue: number = 12;
  @Input() professionalInfo: boolean;
  @Input() applyCouponForPlatform?: boolean;
  @Input() hasCampaignCoupon?: boolean;
  @Input() couponPercent?: number = 0;
  @Input() hasFreeDays: boolean = false;
  @Input() customDomainFlow?: boolean;
  @Input() isBlkOffer?: boolean;
  @Input() everythingInPrevious?: boolean;
  @Input() previousPlan?: string;
  @Input() additionalFeatures?: any[];
  @Input() platformFeatures?: boolean;
  @Input() platformInfo?: any[];
  @Input() isSelected: boolean = false;
  @Input() isPaid?: boolean;

  @Output() onPlanChange = new EventEmitter<ChosenPlan>();
  @Output() proceedToCheckout = new EventEmitter<ChosenPlan>();

  isMobile: boolean = false;
  showVideo: boolean = false;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  public getPlanFeatures(featureType: string) {
    const category = this.subscription?.category?.toLowerCase();
    if (!category || !planFeatures[this.activeTab]?.[category]) {
      return null;
    }

    const planData = planFeatures[this.activeTab][category];
    return planData[featureType] || null;
  }

  public replaceParam(string, params: any = null): string {
    return TextUtils.getText(null, params, string);
  }

  public selectPlan() {
    const chosenPlan: ChosenPlan = {
      id: this.subscription.id,
      title: this.subscription.plan.title,
      tabCategory: this.subscription?.plan?.shortFeatures?.tabCategory,
      price: this.subscription.plan.planPrice,
      type: this.periodSwitchValue === 12 ? "year" : "month",
      planPrice: this.subscription.plan.price,
      coupon: this.subscription.couponCode,
      periodNumber: this.subscription.plan.periodNumber,
    };
      this.proceedToCheckout.emit(chosenPlan);
      return;
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  openVideoPopup(): void {
    this._modalService.open(CopilotVideoComponent, {
      height: 563, width: 1000, hasOutsideRightCloseBtn: true,
      hasCloseBtn: false, backdrop: 'static'
    });
  }

  private _sendEvent(chosenPlan): void {
    const analyticsData = {
      eventCategory: "Free Upgrade Offer",
      eventAction: "Change Subscription",
      eventLabel: chosenPlan.title + " " + chosenPlan.type + "ly",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
